import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getCompType(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}component/type/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function addCompType(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}component/type/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddType() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/component/type/dde`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getByCompType(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}component/type/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateCompType(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}component/type/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}